import { motion } from "framer-motion";
import { FiDownload, FiFileText, FiX } from "react-icons/fi";

interface MealMonitoringDownloadModalProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onDownload: () => void | Promise<boolean>;
}

const MealMonitoringDownloadModal = ({
  open,
  loading,
  onClose,
  onDownload,
}: MealMonitoringDownloadModalProps) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="absolute inset-0 bg-black/25"
        onClick={loading ? undefined : onClose}
      />

      <motion.div
        initial={{ y: "100%", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 320, damping: 30 }}
        className="relative w-full overflow-hidden rounded-t-2xl bg-white"
      >
        <div className="px-6 pb-7 pt-5">
          <div className="flex items-center justify-between border-b border-gray-100 pb-4">
            <h2 className="text-sm font-bold text-[#444]">Download Form</h2>

            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 disabled:opacity-50"
            >
              <FiX className="text-lg" />
            </button>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.85, y: 15 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.25 }}
            className="flex flex-col items-center"
          >
            <motion.div
              animate={{ y: [0, -6, 0] }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="mt-8 flex h-[130px] w-[130px] items-center justify-center rounded-2xl bg-red-50"
            >
              <div className="flex h-[82px] w-[68px] items-center justify-center rounded-lg border-2 border-[#ff7772] bg-white shadow-sm">
                <FiFileText className="text-[42px] text-[#ff7772]" />
              </div>
            </motion.div>

            <h3 className="mt-6 text-base font-bold text-[#444]">
              Download meal form?
            </h3>

            <p className="mt-1 text-center text-[10px] text-gray-400">
              The meal form will be downloaded using the file format provided by
              the server
            </p>

            <div className="mt-5 flex w-full gap-2">
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="flex h-10 flex-1 items-center justify-center rounded-md border border-[#ff7772] bg-white text-xs font-medium text-[#ff7772] disabled:opacity-50"
              >
                Back
              </button>

              <button
                type="button"
                onClick={onDownload}
                disabled={loading}
                className="flex h-10 flex-1 items-center justify-center gap-1.5 rounded-md bg-[#ff7772] text-xs font-semibold text-white disabled:opacity-60"
              >
                {loading ? "Downloading..." : "Download File"}
                {!loading && <FiDownload className="text-sm" />}
              </button>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default MealMonitoringDownloadModal;
